import { useStyletron } from 'baseui'

import { POLL_SCORES, pollColor } from '@/shared/tools/communicationBoardPolls'
import { GAUGE_CENTER, needleTip, segmentPath } from './pollGaugeGeometry'

const NEUTRAL_SCORE = 3

const usePollGauge = (average: number | null) => {
  const [, theme] = useStyletron()

  const segments = POLL_SCORES.map(({ score, colorKey }, index) => ({
    score,
    path: segmentPath(index),
    fill: pollColor(theme, colorKey),
  }))

  return {
    segments,
    center: GAUGE_CENTER,
    tip: needleTip(average ?? NEUTRAL_SCORE),
    needleVisibility: average === null ? 'hidden' : 'visible',
    needleColor: theme.colors.textPulseStrong,
  }
}

export default usePollGauge
